import classnames from 'classnames';
import FilterSectionContext from 'contexts/FilterSectionContext';
import chevronRight16 from 'images/icons/chevron-right-16.svg';
import React, { useContext } from 'react';

interface Props {
  label: string;
  appliedFilters: string[];
  disabled: boolean;
  children: React.ReactNode;
}

const FilterSection: React.FC<Props> = (props: Props) => {
  const { label, appliedFilters, disabled, children } = props;
  const { sectionOpen, setSectionOpen } = useContext(FilterSectionContext);

  /* Handlers */
  function handleOpenSectionClick() {
    if (!disabled) {
      setSectionOpen(label);
    }
  }

  if (sectionOpen !== null && label !== sectionOpen) {
    return null;
  }

  return label === sectionOpen ? (
    <>{children}</>
  ) : (
    <div
      className={classnames('bb-2 row justify-between items-center px4', {
        'cursor-pointer': !disabled,
      })}
      style={{ height: '44px' }}
      onClick={handleOpenSectionClick}
    >
      {appliedFilters.length > 0 ? (
        <div className="column w80">
          <div
            className="secondary-blue font-size-4 medium"
            style={{ opacity: disabled ? '0.5' : '1' }}
          >
            {label}
          </div>
          <div className="font-size-2 black-2 truncate">
            {appliedFilters.map((ap, i, arr) => {
              return (
                <span key={ap}>
                  {`${ap}${i + 1 !== arr.length ? `, ` : ``}`}
                </span>
              );
            })}
          </div>
        </div>
      ) : (
        <span
          aria-disabled={disabled}
          style={{ opacity: disabled ? '0.5' : '1' }}
        >
          {label}
        </span>
      )}
      <div>
        {disabled ? null : (
          <img src={chevronRight16} alt={`Open ${label} filter section`} />
        )}
      </div>
    </div>
  );
};

export default FilterSection;
